import { render, staticRenderFns } from "./PreviewChooserText.vue?vue&type=template&id=1dce27c0&scoped=true&"
import script from "./PreviewChooserText.vue?vue&type=script&lang=ts&"
export * from "./PreviewChooserText.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dce27c0",
  null
  
)

export default component.exports